import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { SessionLobby } from './components/SessionLobby';
import { RhythmGame } from './components/games/RhythmGame';
import { TeaseDenial } from './components/games/TeaseDenial';
import { SyncChallenge } from './components/games/SyncChallenge';
import { TruthDare } from './components/games/TruthDare';
import { Breathing } from './components/games/Breathing';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/session/:sessionId" element={<SessionLobby />} />
        <Route path="/game/rhythm/:sessionId" element={<RhythmGame />} />
        <Route path="/game/tease/:sessionId" element={<TeaseDenial />} />
        <Route path="/game/sync/:sessionId" element={<SyncChallenge />} />
        <Route path="/game/truth/:sessionId" element={<TruthDare />} />
        <Route path="/game/breathing/:sessionId" element={<Breathing />} />
      </Route>
    </Routes>
  );
}

export default App;